import * as React from 'react';
import List from '@material-ui/core/List';

const CustomList = (props) => {
    return <List {...props} />;
};

export { CustomList as List };
